
import { useListsStore } from '@shared/model'
import { AppRoute, pageTitles } from '@shared/config'

import { useDisciplineStore } from './store'
import { getDisciplineName } from './discipline-general-info'

interface DisciplineGeneralTitleReturn {
  refTitle: ComputedRef<string>
}

/** The browser tab names the subject, "Discipline Math", as the legacy page did. */
export const useDisciplineGeneralTitle = (): DisciplineGeneralTitleReturn => {
  const disciplineStore = useDisciplineStore()
  const listsStore = useListsStore()

  const refTitle = computed<string>(() => {
    const code = disciplineStore.getDiscipline?.code
    if (!code) return pageTitles[AppRoute.DisciplinesGeneralInfo]

    return `Discipline ${getDisciplineName(code, listsStore.getLists?.discipline.code)}`
  })

  return {
    refTitle,
  }
}
